// app/monitoraggio/monitoraggio.js

(function () {
    'use strict';
    var controllerId = 'monitoraggioCtr';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$filter', '$routeParams', '_', 'common', 'datacontext', 'sectionMenu', '$translate', monitoraggioCtr]);

    function monitoraggioCtr($rootScope, $scope, $filter, $routeParams, _, common, datacontext, sectionMenu, $translate) {
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = 'Monitoraggio';
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.list = {};

        if (!$rootScope.isAuthorized('STUDENTE'))
            vm.subTitle = "ComplessivaMieiAllievi";
        else
            vm.subTitle = "";

        vm.super = $rootScope.isAuthorized('SUPER');
        
        //filter per Anno: default l'anno corrente o per anno impostato già in altre aree
        if ($rootScope.annoScolastico == 0)
            vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        else
            vm.fAnno = $rootScope.annoScolastico;
        vm.mySessions = true;
        vm.loading = false;

        //Eventi        
        vm.classeChanged = classeChanged;
        vm.annoChanged = function () {
            vm.list.classi = getListClassi();
            $rootScope.annoScolastico = vm.fAnno;
            cerca();
        };
        vm.cerca = cerca;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        vm.list.classi = getListClassi();
                        vm.list.studenti = getListStudenti();
                        vm.list.materie = getListMaterie();
                        getPerformance();
                    });
        }       

        function classeChanged() {
            if (!vm.fClasseId) vm.fClasseId = 0;
            vm.fStudenteId = 0;

            vm.list.studenti = getListStudenti();
        }        

        function getListClassi() {
            var anno = vm.fAnno == null ? -1 : vm.fAnno;            
            return datacontext.classe_getAllList(anno).then(function (data) {
                vm.fClasseId = 0;
                return vm.list.classi = data;
            });
        }

        function getListStudenti() {
            return datacontext.studente_getAllListByClasse(vm.fClasseId).then(function (data) {
                return vm.list.studenti = data;
            });
        }

        function getListMaterie() {
            return datacontext.materia_getAllMaterieDocentiList($rootScope.id).then(function (data) {
                return vm.list.materie = data;
            });
        }

        function getPerformance() {
            $scope.graficoPerformance = {
                'type': 'AreaChart',
                'options': {
                    'legend': { 'position': 'none' },
                    'colors': ['#3C454D'],
                    'vAxis': {
                        'title': $translate.instant('Punteggio') + ' in %',
                        'titleTextStyle': { color: '#333' },
                        'minValue': 0,
                        'maxValue': 100
                    },
                    'hAxis': {
                        'textPosition': 'none',
                        'gridlines': { 'count': 10 }
                    },
                    'pointSize': 8
                },
                'formatters': {
                    'number': [
                        {
                            'columnNum': 1,
                            'decimalSymbol': ',',
                            'fractionDigits': 1,
                            'groupingSymbol': '.'
                        }
                    ]
                }
            };

            $scope.graficoDocentePerformance = {
                'type': 'AreaChart',
                'options': {
                    'legend': { 'position': 'none' },
                    'colors': ['#3C454D', '#F48451'],
                    'vAxis': {
                        'title': $translate.instant('Punteggio') + ' in %',
                        'titleTextStyle': { color: '#333' },
                        'minValue': 0,
                        'maxValue': 100
                    },
                    'hAxis': {
                        'textPosition': 'none',
                        'gridlines': { 'count': 10 }
                    },
                    'pointSize': 8
                },
                'formatters': {
                    'number': [
                        {
                            'columnNum': 1,
                            'decimalSymbol': ',',
                            'fractionDigits': 1,
                            'groupingSymbol': '.'
                        }
                    ]
                }
            };

            if (vm.mySessions) {
                vm.loading = true;
                datacontext.dashboard_getAllStudenteSession(vm.fAnno, vm.fClasseId, vm.fStudenteId, vm.fMateriaId).then(function (data) {
                    vm.showPerformance = true;
                    if (data == null || data.length == 0) {
                        $scope.graficoPerformance.data = {
                            "cols": [
                                { id: "description", label: $translate.instant('Data'), type: "string" },
                                { id: "score", label: $translate.instant('Punteggio'), type: "number" }
                            ],
                            "rows": []
                        };

                        vm.loading = false;
                        return;
                    }
                    
                    vm.sessionCount = data.length;
                    var sortedPerformance = _.sortBy(data, 'Data');
                    vm.primaData = _.first(sortedPerformance).Data;
                    vm.ultimaData = _.last(sortedPerformance).Data;

                    $scope.graficoPerformance.data = {
                        "cols": [
                            { id: "description", label: $translate.instant('Data'), type: "string" },
                            { id: "score", label: $translate.instant('Punteggio'), type: "number" }
                        ],
                        "rows": []
                    };

                    sortedPerformance.forEach(function (obj) {
                        var item = {};
                        item.c = [];

                        var desc = $filter('date')(obj.Data);

                        item.c.push({ v: desc });
                        item.c.push({ v: obj.Percentuale });

                        $scope.graficoPerformance.data.rows.push(item);
                    });

                    vm.loading = false;
                });
            } else {
                //dati raggruppati per data e docente
                vm.loading = true;
                datacontext.dashboard_getStudenteAllDocenteSessions(vm.fAnno, vm.fClasseId, vm.fStudenteId, vm.fMateriaId).then(function (data) {
                    vm.showPerformance = true;
                    if (data == null || data.length == 0) {
                        $scope.graficoPerformance.data = {
                            "cols": [
                                { id: "description", label: $translate.instant('Data'), type: "string" },
                                { id: "score", label: $translate.instant('Punteggio'), type: "number" }
                            ],
                            "rows": []
                        };

                        vm.loading = false;
                        return;
                    }

                    vm.sessionCount = data.length;
                    var sortedPerformance = _.sortBy(data, 'Data');
                    vm.primaData = _.first(sortedPerformance).Data;
                    vm.ultimaData = _.last(sortedPerformance).Data;

                    $scope.graficoPerformance.data = {
                        "cols": [
                            { id: "description", label: $translate.instant('Data'), type: "string" },
                            { id: "score", label: $translate.instant('Punteggio'), type: "number" },
                            //{ id: "teacher", label: $translate.instant('Docente'), type: "string" },
                            { id: "style", label: "style", type: "string", role: "style" }
                            
                        ],
                        "rows": []
                    };

                    sortedPerformance.forEach(function (obj) {
                        var item = {};
                        item.c = [];

                        var desc = $filter('date')(obj.Data);

                        item.c.push({ v: obj.Docente + ' - ' + desc });
                        item.c.push({ v: obj.Percentuale });
                        if (obj.DocenteId != $rootScope.id)
                            item.c.push({ v: 'point { fill-color: #F48451 }' });
                        
                            
                        $scope.graficoPerformance.data.rows.push(item);
                        vm.loading = false;
                    });
                });
            }
            
        }
        
        function cerca() {
            if (!$rootScope.isAuthorized('STUDENTE'))
                vm.subTitle = "ComplessivaAllievi";
            else
                vm.subTitle = "";

            if (vm.fStudenteId) {
                var selStud = _.find(vm.list.studenti, { 'Id': vm.fStudenteId });

                vm.subTitle = " " + $translate.instant('Allievo') + " " + selStud.Name;
            }
            else if (vm.fClasseId) {
                var selClasse = _.find(vm.list.classi, { 'Id': vm.fClasseId });

                vm.subTitle = " " + $translate.instant('Classe') + " " + selClasse.Name;
            }

            vm.loading = false;

            getPerformance();
        }
    }
})();